const pre = '/bcos/event/';

export default {
    path: '/bcos/event',
    title: '订阅事件',
    header: '',
    icon: 'md-cube',
    children: [
        {
            path: `${pre}blockEvent`,
            title: '出块事件',
        },
        {
            path: `${pre}contractEvent`,
            title: '合约事件',
        },
    ]
}
